import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import axios from 'axios'
import JSEncrypt from 'encryptlong'
import './permission.js'
// import Vuetify from 'vuetify'
// import 'vuetify/dist/vuetify.min.css'

axios.defaults.baseURL = '/api'

axios.defaults.secure = false
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.withCredentials = true

// http request 拦截器
axios.interceptors.request.use(config => {
  const randomNum = Math.floor(Math.random() * 100000)
  const timestamp = Math.floor(Date.now() / 1000)

  let uncryptedText
  // 判断是否为文件上传请求（FormData）
  if (config.data instanceof FormData) {
    // 文件上传签名不含 reqBody，与C++保持一致
    uncryptedText = 'rnumbers=' + randomNum + '&timestamp=' + timestamp
  } else {
    // 普通JSON请求
    const jsonReqBody = config.data
    const strReqBody = JSON.stringify(jsonReqBody)
    uncryptedText = (strReqBody && Object.keys(config.data).length > 0 ? 'reqBody=' + strReqBody : 'reqBody=') + '&rnumbers=' + randomNum + '&timestamp=' + timestamp
  }

  const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  if (userInfo && userInfo.isLogin) {
    uncryptedText += '&userId=' + userInfo.userId + '&userSession=' + userInfo.sessionId
    config.headers.userId = userInfo.userId
    config.headers.userSession = userInfo.sessionId
  }

  const encryptor = new JSEncrypt()
  const pubKey = '-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDqoIUktPNqNWe68ixwZPqke/wA\nDD31wOumI3mDkYhSSSaDugPmxRgWptGblDDw2ygoR97XZyNY3Gn1RRO/91ATpAmN\nYd6C4ffdbxgrcrCbADPbzTG3xAccxRvemLlf9EZSeTD58NEE6wpAJIihaGPQw0Hc\nMCqA4aYYY12Kq4edPwIDAQAB\n-----END PUBLIC KEY-----'
  encryptor.setPublicKey(pubKey)
  const sign = encryptor.encryptUnicodeLong(uncryptedText)

  // Content-Type 处理：对于 FormData 不设置，让浏览器自动添加 boundary
  if (!config.headers['Content-Type']) {
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    }
  }

  config.headers.rnumbers = randomNum
  config.headers.timestamp = timestamp
  config.headers.sign = sign

  return config
}, error => {
  return Promise.reject(error)
})

// http response 拦截器
axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response) {
    switch (error.response.status) {
      case 401:
      // 返回 401 清除token信息并跳转到登录页面
      // store.commit(types.LOGOUT);
        router.currentRoute.path !== '/login' &&
        router.replace({
          path: '/login',
          query: { redirect: router.currentRoute.fullPath }
        })
    }
  }
  return Promise.reject(error) // 返回接口返回的错误信息
})

const app = createApp(App)

app.config.globalProperties.$axios = axios

// app.use(Vuetify)

// https://element.eleme.cn/#/zh-CN
app.use(ElementPlus)

app.use(store).use(router).mount('#app')
